import { configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Changed to localStorage

import rootReducer from "./rootReducer";
import sessionStorage from "redux-persist/es/storage/session";

const persistConfig = {
  key: "root",
  storage: sessionStorage,
};

const appReducer = (state, action) => {
  if (action.type === "SIGNOUT") {
    sessionStorage.removeItem("persist:root"); // Make sure to clear localStorage
    return rootReducer(undefined, action);
  }
  return rootReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, appReducer);

export default configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializableCheck for persisted state
    }),
  // middleware: [thunk] // This line seems unnecessary if you’re using default middleware.
});
